import { Component, Input, OnInit } from '@angular/core';
import { AppComponent } from 'app/app.component';
import {
    ExportFileTypeEnum, RiderVehicleTypeEnum,
    ChallengeQuestTypeEnum, ChallengeQuestTypeModel
} from 'app/models';
import {
    ConfigService, GeoZoneService, AppDataService,
    QuestService
} from 'app/services';
import { Utils } from 'app/utils';
import moment from 'moment';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'report-quests',
    templateUrl: './report-quests.component.html',
    styleUrls: ['./report-quests.component.scss'],
    providers: [MessageService]
})
export class ReportQuestsComponent implements OnInit
{
    constructor(public questService: QuestService,
        public configService: ConfigService,
        public app: AppComponent,
        public messageService: MessageService,
        private geoZoneService: GeoZoneService,
        private appData: AppDataService) { }

    public quests!: any;
    public colums!: any;

    public selectedDateRange: Date[] = [];

    private searchTimer: number = 0;

    public challengeQuestTypeList = ChallengeQuestTypeModel.ChallengeQuestTypeList;

    public exportFileTypeEnum = ExportFileTypeEnum;

    public blockedPanel: boolean = false;
    public loadingExportData: boolean = false;

    public filterQuests: any = {
        challengeQuestType: ChallengeQuestTypeEnum.GuaranteedEarnings
    };

    ngOnInit(): void {
        this.selectedDateRange[1] = new Date();
        this.selectedDateRange[0] = new Date();
        this.selectedDateRange[0].setDate(new Date().getDate() - 30);

        this.getColums();
    }

    private getColums() {
        if (this.filterQuests.challengeQuestType === ChallengeQuestTypeEnum.GuaranteedEarnings) {
            this.colums = [
                {
                    field: 'Date', header: 'Date', width: '20%'
                },
                {
                    field: 'Zone', header: 'Zone', width: '20%'
                },
                {
                    field: 'Timeblock', header: 'Timeblock', width: '20%'
                },
                {
                    field: 'DriverId', header: 'Driver Id', width: '20%'
                },
                {
                    field: 'VehicleTypeText', header: 'Vehicle Type', width: '20%'
                },
                {
                    field: 'DriverName', header: 'Driver Name', width: '20%'
                },
                {
                    field: 'Compliant', header: 'Compliant', width: '20%'
                },
                {
                    field: 'CompletedTrips', header: 'Completed Trips', width: '20%'
                },
                {
                    field: 'TotalRideEarnings', header: 'Total Ride Earnings', width: '20%'
                },
                {
                    field: 'RewardAmount', header: 'GE Amount', width: '20%'
                },
                {
                    field: 'Status', header: 'GE Status', width: '20%'
                },
                {
                    field: 'ReasonOfDisqualification', header: 'Reason of Disqualification', width: '20%'
                }
            ];
        } else {
            this.colums = [
                {
                    field: 'Date', header: 'Date', width: '20%'
                },
                {
                    field: 'Zone', header: 'Zone', width: '20%'
                },
                {
                    field: 'Timeblock', header: 'Timeblock', width: '20%'
                },
                {
                    field: 'DriverId', header: 'Driver Id', width: '20%'
                },
                {
                    field: 'VehicleTypeText', header: 'Vehicle Type', width: '20%'
                },
                {
                    field: 'DriverName', header: 'Driver Name', width: '20%'
                },
                {
                    field: 'CompletedTrips', header: 'Completed Trips', width: '20%'
                },
                {
                    field: 'TotalRideEarnings', header: 'Total Ride Earnings', width: '20%'
                },
                {
                    field: 'RewardAmount', header: 'Incentives Earned', width: '20%'
                },
                {
                    field: 'Status', header: 'Incentive Status', width: '20%'
                }
            ];
        }

        this.getQuestReport();
    }

    private getQuestReport() {
        this.blockedPanel = true;

        const dto = {
            StartDateTime: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
            EndDateTime: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),
            ChallengeQuestType: this.filterQuests.challengeQuestType,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.questService.getQuestReport(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.blockedPanel = false;
                    return;
                }
                this.blockedPanel = false;

                this.quests = data.Quests;

                this.quests.forEach((item: any) => {
                    item.Date = moment(Utils.utcToLocalDate(item.StartDateTime)).format('DD MMM YYYY');
                    item.Timeblock = moment(Utils.utcToLocalDate(item.StartDateTime)).format('hh:mm A') + ' - ' +
                        moment(Utils.utcToLocalDate(item.EndDateTime)).format('hh:mm A');
                    item.Compliant = item.CompliantText;
                    item.TotalRideEarnings = '₱' + item.TotalRideEarnings;
                    item.RewardAmount = '₱' + item.RewardAmount;
                });
            })
            .catch(err => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
                this.blockedPanel = false;
            });
    }

    public handleFilterChange(event: any) {
        if (this.selectedDateRange[1]) {
            if (this.searchTimer) {
                window.clearTimeout(this.searchTimer);
            }

            this.searchTimer = window.setTimeout(() => {
                this.getColums();
                this.searchTimer = 0;
            }, 1500);
        }
    }

    public exportQuestReport(fileType: ExportFileTypeEnum) {
        this.loadingExportData = true;

        const dto = {
            StartDateTime: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
            EndDateTime: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),
            ChallengeQuestType: this.filterQuests.challengeQuestType,
            FileType: fileType,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.questService.exportQuestReport(dto, this.messageService)
            .then(data => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Success' });

                Utils.saveFileResponse(data, 'Quest report' + moment(new Date()).format('DD MMM YYYY hh:mm:ss A'), fileType);

                this.loadingExportData = false;
            })
            .catch(err => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
                this.loadingExportData = false;
            });
    }
}
